module.exports = {render:function anonymous(
) {
with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"remove--s","viewBox":"0 0 1500 1500"}},[_c('title',[_v("remove--s")]),_c('path',{attrs:{"d":"M1334.8 234.7l-70-70.1-519.9 510.1-510-510.1-70 70.1 509.9 519.9-509.9 510.1 70 70 510-510.1 519.9 510.1 70-70-509.9-510.1z"}})])}
}};